import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faAmazon, faApple, faSpotify, faDeezer, faItunes } from '@fortawesome/free-brands-svg-icons';
import Footer from './Footer';

// Original brand colors for platforms
const platformColors = {
  'YouTube': '#FF0000',
  'Spotify': '#1DB954',
  'Apple Music': '#ffffff',
  'iTunes Store': '#FE2D63',
  'Amazon Music': '#FF9900',
  'Deezer': '#FF0095',
};

// Icon mapping for platforms
const platformIcons = {
  'YouTube': faYoutube,
  'Spotify': faSpotify,
  'Apple Music': faApple,
  'iTunes Store': faItunes,
  'Amazon Music': faAmazon,
  'Deezer': faDeezer,
};

// SingleMusic component
const SingleMusic = ({ music }) => (
  <div className="bg-black text-white flex flex-col items-center p-2 sm:p-4 md:p-8 lg:p-12 overflow-y-auto">
    {/* Title of the Album */}
    <h1 className="text-xl sm:text-xl md:text-xl lg:text-3xl font-ettlora mb-2 sm:mb-4 text-center">{music.title}</h1>
    
    {/* Video Thumbnail */}
    <img src={music.thumbnail} alt={music.title} className="w-full sm:max-w-sm md:max-w-md lg:max-w-lg mb-4 sm:mb-6 border border-gray-600 rounded-lg" />
    
    {/* Streaming Platforms */}
    <div className="w-full sm:max-w-sm md:max-w-md lg:max-w-lg overflow-x-auto">
      {['YouTube', 'Spotify', 'iTunes Store', 'Apple Music', 'Amazon Music', 'Deezer'].map((platform, index) => {
        // Construct the link based on the music object
        const platformLink = music[`${platform.toLowerCase().replace(/\s/g, '_')}_link`];

        return (
          <div key={index} className="flex justify-between items-center mb-4 bg-gray-800 p-4 rounded-lg border border-gray-600">
            <div className="flex items-center mb-2">
              <FontAwesomeIcon icon={platformIcons[platform]} size="2x" color={platformColors[platform]} />
              <h2 className="ml-2 text-lg">{platform}</h2>
            </div>
            {platformLink && (
              <a 
                href={platformLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className={`text-white bg-black hover:bg-black py-2 px-4 rounded transition duration-200 ${platform === 'YouTube' ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-600 hover:bg-gray-700'}`}
              >
                {platform === 'YouTube' ? 'Watch' : 'Listen'}
              </a>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default SingleMusic;
